/**
 * Serviço de Clínicas
 * Comunicação com API de clínicas
 */

import api from './api';

const clinicaService = {
  /**
   * Listar todas as clínicas
   */
  listarClinicas: async (params = {}) => {
    const response = await api.get('/clinicas', { params });
    return response;
  },

  /**
   * Buscar clínica por ID
   */
  buscarClinica: async (id) => {
    const response = await api.get(`/clinicas/${id}`);
    return response;
  },

  /**
   * Criar nova clínica
   */
  criarClinica: async (dados) => {
    const response = await api.post('/clinicas', dados);
    return response;
  },

  /**
   * Atualizar clínica
   */
  atualizarClinica: async (id, dados) => {
    const response = await api.put(`/clinicas/${id}`, dados);
    return response;
  },

  /**
   * Desativar clínica
   */
  desativarClinica: async (id, motivo) => {
    const response = await api.patch(`/clinicas/${id}/desativar`, { motivo });
    return response;
  },

  /**
   * Reativar clínica
   */
  reativarClinica: async (id) => {
    const response = await api.patch(`/clinicas/${id}/reativar`);
    return response;
  },

  /**
   * Buscar usuários de uma clínica
   */
  buscarUsuariosClinica: async (id) => {
    const response = await api.get(`/clinicas/${id}/usuarios`);
    return response;
  },

  /**
   * Relatório financeiro da clínica
   */
  relatorioFinanceiro: async (id, params = {}) => {
    const response = await api.get(`/clinicas/${id}/relatorio`, { params });
    return response;
  },

  /**
   * Listar clínicas para painel operacional
   */
  listarClinicasOperacional: async (params = {}) => {
    const response = await api.get('/operacional/clinicas', { params });
    return response;
  },

  /**
   * Buscar perfil completo de uma clínica
   */
  getPerfilCompletoClinica: async (clinicaId) => {
    const response = await api.get(`/operacional/clinicas/${clinicaId}/perfil`);
    return response;
  },

  // ─── Carnê Leão / Recibos PF ─────────────────────────────────────────────

  /**
   * Listar lançamentos PF de uma clínica (com info do recibo por lançamento)
   */
  listarCarneLeao: async (clinicaId) => {
    const response = await api.get(`/operacional/clinicas/${clinicaId}/carne-leao`);
    return response;
  },

  /**
   * Upload de recibo para um lançamento específico
   */
  uploadRecibo: async (faturamentoId, formData) => {
    const response = await api.post(
      `/operacional/faturamentos/${faturamentoId}/recibo`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response;
  },

  /**
   * Download do recibo — obtém URL pré-assinada do S3 e abre em nova aba
   */
  downloadRecibo: async (faturamentoId) => {
    const response = await api.get(`/operacional/faturamentos/${faturamentoId}/recibo`);
    const { url } = response;
    if (!url) throw new Error('URL do recibo não encontrada');
    window.open(url, '_blank', 'noopener,noreferrer');
  },

  /**
   * Remover recibo de um lançamento
   */
  removerRecibo: async (faturamentoId) => {
    const response = await api.delete(`/operacional/faturamentos/${faturamentoId}/recibo`);
    return response;
  },

  toggleCarneLeaoDespesa: async (despesaId) => {
    const response = await api.patch(`/despesas/${despesaId}/carne-leao`);
    return response;
  },

  emitirNotaAdmin: async (faturamentoId) => {
    const response = await api.post(`/operacional/faturamentos/${faturamentoId}/emitir-nota`);
    return response;
  },

  cancelarNotaAdmin: async (faturamentoId, motivo) => {
    const response = await api.delete(`/operacional/faturamentos/${faturamentoId}/nota`, { data: { motivo } });
    return response;
  },

  /**
   * Visualizar PDF da nota fiscal (manual ou emitida via API) em nova aba
   */
  visualizarNotaManual: async (faturamentoId) => {
    const token = localStorage.getItem('token');
    const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    const response = await fetch(`${baseURL}/operacional/faturamentos/${faturamentoId}/nota-manual`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Nota fiscal não encontrada');
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener,noreferrer');
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  },
};

export default clinicaService;
